// Types for agent data structure
export interface AgentCreator {
	canonicalAccountId: string;
	accountId: string;
	accountStatus: string;
	name: string;
	id: string;
}

export interface AgentNode {
	id: string;
	identityAccountId: string;
	name: string;
	description: string;
	creatorType: string;
	externalConfigReference: string | null;
	instructions: string;
	conversationStarters: string[];
	creator: AgentCreator;
}

export interface AgentEdge {
	node: AgentNode;
}

export interface AgentStudioGetAgentsResponse {
	agentStudio_getAgents: {
		edges: AgentEdge[];
	};
}

export const KNOWLEDGE_CARD_AGENT_SEARCH_OPERATION_NAME = 'KnowledgeCardAgentSearchQuery';
export const KnowledgeCardAgentSearchQuery = `
query ${KNOWLEDGE_CARD_AGENT_SEARCH_OPERATION_NAME}($cloudId: String!, $input: AgentStudioAgentQueryInput!, $limit: Int!) {
    agentStudio_getAgents(cloudId: $cloudId, input: $input, first: $limit) 
    @optIn(to: "AgentStudio")
    {
      edges {
        node {
          id
          identityAccountId
          name
          description
          creator {
            canonicalAccountId
            accountId
            accountStatus
            id
            name
          }
          creatorType
          externalConfigReference
          instructions
          conversationStarters
        }
      }
    }
  }`;
